import { BreadcrumbType, CategoriaNode, PaginaNode } from '@gql/graphql'
import { Breadcrumbs, WContainer, WImage } from '../../atoms'
import styles from './GenericHero.module.sass'

interface Props {
  pagina: PaginaNode | { titolo?: string; descrizione?: string; breadcrumbs?: BreadcrumbType[] }
  logo?: string
  className?: string
}

const GenericHero = (props: Props) => {
  const { pagina = undefined, logo = undefined, className = '' } = props

  return pagina ? (
    <div className={`${styles.root} ${logo ? styles['root--logo'] : ''} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          {!!pagina.breadcrumbs?.length && (
            <Breadcrumbs className={styles.breadcrumbs} breadcrumbs={pagina.breadcrumbs} />
          )}
          {(!!pagina.titolo || !!pagina.descrizione || !!logo) && (
            <div className={styles.main}>
              <div className={styles.content}>
                {!!pagina.titolo && <h1 className={styles.title}>{pagina.titolo}</h1>}
                {!!pagina.descrizione && (
                  <div className={styles.textContainer}>
                    {!!pagina.descrizione && (
                      <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
                      />
                    )}
                  </div>
                )}
              </div>
              {!!logo && (
                <div className={styles.logoBox}>
                  <WImage
                    className={styles.logo}
                    maxHeight={92}
                    maxWidth={190}
                    src={logo}
                    alt={pagina.titolo}
                    priority
                    loading="eager"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default GenericHero
